import styled from "styled-components"

import media from "../../../styles/media"
import { Nav, NavButton } from "../Nav"

export const RosterNav = styled(Nav)`
  display: flex;
  flex-direction: column;
  padding-top: 0px;
  font-family: StanleyBold, serif;
  font-size: 24px;

  ${media.tablet`
    display: ${props => (props.expanded ? "flex" : "none")};
    opacity: ${props => (props.expanded ? 1 : 0)};
    border: none;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    font-size: 21px;
    line-height: 30px;
    margin-left: 22px;
   
    ul {
      margin-top: 0;
    }
    
    transition: opacity 500ms ease-in-out 200ms, display 100ms ease-in-out 600ms;
  `}
`

export const RosterNavButton = styled(NavButton)`
  color: ${props =>
    props.active ? props.theme.black : props.theme.lightGrey2};
`
